import React from 'react';
import { SurgeryHeader } from 'src/pages/orders/components/orderDetails/orderSummary/shippingDetails/ShippingDetails.styled';
import {
    CreditContainer,
    CreditDataContiner,
    CreditFonts,
} from 'src/pages/orders/components/orderDetails/billingSummary/adjustments/Adjustments.styled';
import AdjustmentsProducts from 'src/pages/orders/components/orderDetails/billingSummary/adjustments/AdjustmentProducts';
import { priceFormatObj } from 'src/pages/consignmentBilling/utils/eventHandlerUtil';
import { setCurrencyFormat } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
const AdjustmentContainer = ({
    headerTitle,
    adjustment,
    products,
    handleSetItemClick,
    ordersList,
}) => {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <SurgeryHeader
                mbPaddingLeft={'17px'}
                mbMarginLeft={'-17px'}
                mbWidth={'110%'}
            >
                {headerTitle}
            </SurgeryHeader>
            <CreditContainer>
                {adjustment?.creditOrderNo ? (
                    <CreditDataContiner>
                        <CreditFonts creditHeader>
                            {t('orders.index.creditorder')}
                        </CreditFonts>
                        <CreditFonts>{adjustment.creditOrderNo}</CreditFonts>
                    </CreditDataContiner>
                ) : null}
                {adjustment?.price || adjustment?.poNumber ? (
                    <CreditDataContiner>
                        <CreditFonts creditHeader>
                            {t('orders.index.amountcredit')}
                        </CreditFonts>
                        <CreditFonts>
                            {adjustment?.price
                                ? setCurrencyFormat(adjustment.price)
                                : null}
                            {adjustment?.poNumber ? (
                                <>
                                    {t('orders.index.topo')}{' '}<span className="orders-adjustment-po-number-dt-mask">{adjustment.poNumber}</span>
                                </>
                            ) : null}
                        </CreditFonts>
                    </CreditDataContiner>
                ) : null}
            </CreditContainer>
            {products?.length > 0 ? (
                <>
                    <AdjustmentsProducts
                        adjustmentsProducts={products}
                        handleSetItemClick={handleSetItemClick}
                        ordersList={ordersList}
                    />
                </>
            ) : null}
        </React.Fragment>
    );
};

export default AdjustmentContainer;
